import * as React from "react";
import { Typography, withStyles, Menu, MenuItem } from "@material-ui/core";
import { Map, Close, MoreHoriz } from "@material-ui/icons";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import i18n from "i18n";
import ReactExport from "react-data-export";
import { TakeOffService } from "modules/takeOff/TakeOffService";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { WBSStore } from "modules/WBS/WBSStore";
import {
  exportTakeOffFormatingReport,
  exportTakeOffReport,
} from "../../../costPlan/assets/excelReports/export";
import { EModelMapTab } from "common/enums";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

const styles = (theme) => ({
  topBar: {
    backgroundColor: "#474747",
    height: "30px",
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
  },
  map: {
    fontSize: "15px",
    marginRight: "8px",
    color: "#ABC200",
  },
  topBarText: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    color: "#ABC200",
    textTransform: "uppercase" as any,
  },
  close: {
    color: "#bcbcbc",
    fontSize: "22px",
    // float: "right",
    cursor: "pointer",
  },
  moreUnselected: {
    color: "#bcbcbc",
    fontSize: "22px",
    marginLeft: "auto",
    marginRight: "10px",
    cursor: "pointer",
  },
  cardMenu: {
    "& > div > *": {
      backgroundColor: "#242424",
    },

    "& > div > ul > li": {
      fontFamily: "Roboto !important",
      fontSize: "11px !important",
      fontWeight: "400 !important" as any,
      color: "#e2e2e3 !important",
    },
  },
});

type IProps = {
  name: string;
  classes: any;
  updateResources?: boolean;
};

class HeaderContainer extends React.Component<IProps> {
  state = {
    anchorEl: null,
    multiDataSet: [],
    multiDataSet2: [],
  };

  static defaultProps = {
    updateResources: false,
  };

  handleClickOptCard = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    this.killEvent(event);
  };

  handleCloseOptCard = (event) => {
    this.setState({ anchorEl: null });
    this.killEvent(event);
  };

  killEvent = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  handleExportResourcesFile = (event) => {
    // Formata os dados conforme usado no react-data-export
    let takeOffName;
    if (TakeOffStore.takeOffModelMap) {
      takeOffName = TakeOffStore.takeOffModelMap.data.name;
    }
    if (TakeOffStore.swipeTab === EModelMapTab.FILTER) {
      exportTakeOffReport(takeOffName);
    } else {
      exportTakeOffFormatingReport(takeOffName);
    }
  };

  render() {
    const { classes } = this.props;
    const openMenu = Boolean(this.state.anchorEl);
    let exportOption = (
      <Menu
        id="long-menu"
        anchorEl={this.state.anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={openMenu}
        onClose={this.handleCloseOptCard}
        PaperProps={{
          style: {
            width: TakeOffStore.swipeTab === EModelMapTab.FILTER ? 240 : 260,
          },
        }}
        className={classes.cardMenu}
        style={{ top: 56 }}
      >
        <MenuItem
          key={0}
          selected={false}
          onClick={this.handleExportResourcesFile}
        >
          {TakeOffStore.swipeTab === EModelMapTab.FILTER
            ? i18n.wbs.exportTakeOffxlsx
            : i18n.wbs.exportFormatxlsx}
        </MenuItem>
      </Menu>
    );
    return (
      <div className={classes.topBar}>
        <Map className={classes.map} />
        <Typography className={classes.topBarText} component="span">
          {this.props.name}
        </Typography>
        <div style={{ marginLeft: "auto", height: "22px" }}>
          {!this.props.updateResources &&
            TakeOffStore.swipeTab !== EModelMapTab.CONFIGURATION && (
              <MoreHoriz
                className={classes.moreUnselected}
                onClick={this.handleClickOptCard}
              />
            )}
          {TakeOffStore.swipeTab !== EModelMapTab.CONFIGURATION && exportOption}
          <Close
            className={classes.close}
            onClick={() => {
              TakeOffStore.layerTakeOffList = false;
              WBSStore.updateComposition = false;
              WBSStore.replaceComposition = false;
              TakeOffStore.hasErrorFilter = false;
              ModelMapStore.modelMapFormat = [];
              TakeOffStore.setSwipeTab(EModelMapTab.FILTER);
            }}
          />
        </div>
        <ExcelFile
          filename={
            DevelopmentStore.developmentSelected.data.name +
            " - " +
            (TakeOffStore.takeOffModelMap !== undefined
              ? TakeOffStore.takeOffModelMap.data.name
              : " model map")
          }
          element={<div id="excel_id"></div>}
        >
          {TakeOffStore.swipeTab == EModelMapTab.FILTER ? (
            <ExcelSheet
              dataSet={this.state.multiDataSet}
              name="Take Off Itens"
            />
          ) : (
            <ExcelSheet dataSet={this.state.multiDataSet2} name="Formatação" />
          )}
        </ExcelFile>
      </div>
    );
  }
}
export default withStyles(styles)(HeaderContainer);



// WEBPACK FOOTER //
// ./src/modules/takeOff/components/layouts/Header.tsx